interface rawOption {
  id: string
  name: string
}

export const transformFilterOptions = (filters: rawOption[]) => {
  if (!filters || !filters.length) return []

  return filters.map((filter: rawOption) => ({
    value: filter.id,
    label: filter.name,
  }))
}
